<h1 mat-dialog-title>{{ 'ADDITIONAL_FIELDS.manual' | translate }}</h1>
<mat-dialog-content class="grid">
  <mat-form-field>
    <mat-label>{{ 'COMMON.type' | translate }}</mat-label>
    <mat-select #typeSelect [formControl]="form.controls.type" (valueChange)="changeFormGroup(typeSelect.value)">
      @for (type of types; track type) {
        <mat-option [value]="type">
          {{ type }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <app-addition-form [formGroup]="form"
    [fields]="dialogData.additionFields"
    [fieldMap]="dialogData.fieldMap$ | async"
    [goods]="dialogData.goods$ | async"
    [senders]="dialogData.senders$ | async"
    [statuses]="dialogData.statuses$ | async"
    [storehouses]="dialogData.storehouses$ | async">
  </app-addition-form>

  <app-button-group style="margin: 5px 0;">
    <button [mat-dialog-close]="form.value"
      [disabled]="form.invalid || invalidName"
      color="primary"
      mat-raised-button>
      {{ 'COMMON.create' | translate }}
    </button>
  </app-button-group>
</mat-dialog-content>
